export type AnalyticsSection =
  | 'users'
  | 'social'
  | 'projects'
  | 'quotations'
  | 'jobs'
  | 'marketplace'
  | 'broker'
  | 'catalog'
  | 'platform';

export type MetricTrend = 'up' | 'down' | 'flat' | 'na';

export interface MetricResult {
  key: string;
  label: string;
  section: AnalyticsSection;
  current: number;
  previous: number;
  delta: number;
  deltaPercent: number | null;
  trend: MetricTrend;
  dimensions: Record<string, string>;
}

export interface AnalyticsOverviewResponse {
  period: {
    from: string;
    to: string;
    compareFrom: string;
    compareTo: string;
    compareMode: 'auto' | 'explicit';
    timezone: string;
  };
  sections: Partial<Record<AnalyticsSection, { metrics: MetricResult[] }>>;
  report: {
    meta: {
      title: string;
      generatedAt: string;
      timezone: string;
      periodLabel: string;
      comparePeriodLabel: string;
      compareMode: 'auto' | 'explicit';
      filtersApplied: {
        includeDeleted: boolean;
        usersValidatedOnly: boolean;
        sections: AnalyticsSection[] | 'all';
      };
    };
    rows: Array<{
      section: AnalyticsSection;
      sectionLabel: string;
      metricKey: string;
      metricLabel: string;
      current: number;
      previous: number;
      delta: number;
      deltaPercent: number | null;
      trend: MetricTrend;
      dimensions: Record<string, string>;
    }>;
  };
}

export interface AnalyticsReportResponse {
  meta: AnalyticsOverviewResponse['report']['meta'];
  rows: AnalyticsOverviewResponse['report']['rows'];
}

export interface AdminAnalyticsFilters {
  from: string;
  to: string;
  compareFrom: string | null;
  compareTo: string | null;
  useExplicitCompare: boolean;
  includeDeleted: boolean;
  usersValidatedOnly: boolean;
  activeSection: AnalyticsSection | 'all';
}

export const ANALYTICS_SECTIONS: AnalyticsSection[] = [
  'users',
  'social',
  'projects',
  'quotations',
  'jobs',
  'marketplace',
  'broker',
  'catalog',
  'platform',
];

export const ANALYTICS_SECTION_LABELS: Record<AnalyticsSection, string> = {
  users: 'Usuarios',
  social: 'Social y muro',
  projects: 'Obras',
  quotations: 'Cotizaciones',
  jobs: 'Bolsa de trabajo',
  marketplace: 'Marketplace',
  broker: 'Seguros',
  catalog: 'Catálogo',
  platform: 'Plataforma',
};
